import React from 'react';
import { Box, Typography } from '@mui/material';
import Layout from '../../../../components/Layout';
import AppBreadcrumbs from '../../../../components/AppBreadcrumbs';
import PDFViewer from '../../../../components/PDFViewer';
import { StyledStickyBreadcrumbBox } from '../../TeacherToolbox.styled';
import { SHARED_BUCKET_URL } from '../../../../variables/constant';
import useRubricIndicatorAndStandards from '../rubricIndicatorStandards-hook';
import { ScoreSchemeTitleKeys } from '../../../../variables/types';

const breadcrumb = [{
  label: 'Toolbox',
  route: '/toolbox',
},
{
  label: 'Rubric, Indicators, & standards',
  route: '/toolbox/rubric-indicators-standards',
},
{
  label: 'k-5 standards',
}];

const StandardsK5View = () => {
  const { user } = useRubricIndicatorAndStandards();
  return (
    <Layout>
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
      >
        <StyledStickyBreadcrumbBox>
          <Typography variant="pageTitle">K-5 Standards</Typography>
          <AppBreadcrumbs breadcrumb={breadcrumb}/>
        </StyledStickyBreadcrumbBox>
        <Box>
          <PDFViewer
            downloadFile
            pdfLink={
              (user?.score_scheme.title_key === ScoreSchemeTitleKeys.Scheme1)
                ? `${SHARED_BUCKET_URL}/pdfs/TexasScoring/StandardKTo5.pdf` : `${SHARED_BUCKET_URL}/pdfs/StandardScoring/StandardKTo5.pdf`
            }
            downloadLink="StandardsKTo5.pdf"
          />
        </Box>
      </Box>
    </Layout>
  );
};

export default React.memo(StandardsK5View);
